import {
  BackendError,
  ParsedError,
  ParsedErrorResult,
} from '@core-interfaces/global/error';

export class ErrorParseUtil {
  static parseErrorResponse(errors: any[]): ParsedErrorResult {
    const result: ParsedErrorResult = {
      hasErrors: false,
      errors: [],
    };

    result.errors = errors.map((backendError) =>
      this.parseBackendError(backendError)
    );
    result.hasErrors = result.errors.length > 0;
    result.firstError = result.errors[0];
    return result;
  }

  private static parseBackendError(backendError: BackendError): ParsedError {
    return {
      message: backendError.message,
      statusCode: backendError.extensions?.statusCode,
      code: backendError.extensions?.code,
      errorCode: backendError.extensions?.errorCode,
      field: backendError.extensions?.field,
      path: backendError.path,
      originalError: backendError,
    };
  }
}
